import { MultiItemSelection } from "./MultiItemSelection";
import { dictionaryValueMap } from "datasheets/model/utils/dictionaryUtils";
import { SingleSelection } from "./SingleSelection";

export function KeyedElementSelection({
  title,
  labelToKey,
  keyToLabel,
  selection,
  availableKeys,
  onChange,
  isSingleSelection,
  showTitle = true,
}: {
  title: string;
  labelToKey: { [label: string]: string };
  keyToLabel: { [key: string]: string };
  selection: string[] | string | undefined;
  availableKeys: string[];
  onChange:
    | ((columns: { [index: number]: string }) => void)
    | ((column: string) => void);
  isSingleSelection: boolean;
  showTitle?: boolean;
}) {
  return isSingleSelection ? (
    <SingleSelection
      showTitle={showTitle}
      title={title}
      onChange={onChange as (column: string) => void}
      options={labelToKey}
      selection={!!selection ? (selection as string) : ""}
    />
  ) : (
    <MultiItemSelection
      title={title}
      selectedItems={(selection as string[]).map((id) => keyToLabel[id])}
      availableSelections={availableKeys.map((id) => keyToLabel[id])}
      onChange={(items) =>
        (onChange as (columns: { [index: number]: string }) => void)(
          dictionaryValueMap(items, (name) => labelToKey[name])
        )
      }
    ></MultiItemSelection>
  );
}
